module.exports = __webpack_public_path__ + "img/sidebar-icon-dashboard.2e857a43.svg";